import api from '../..'
import { IEnrolModel } from 'models/enrol.model'

export type CreateApplicationAttributes = Pick<
  IEnrolModel,
  | 'state'
  | 'stateAdmin'
  | 'note'
  | 'userId'
  | 'courseId'
  | 'answer'
  | 'answerAdmin'
  | 'synchronousCourseEnrol'
>

const createApplication = (enrol: CreateApplicationAttributes) => {
  return api.post(`administration/applications`, { enrol })
}

export default createApplication
